import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Home = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  // Simula una verificación de la sesión del usuario
  useEffect(() => {
    const checkUserSession = async () => {
      const storedUser = sessionStorage.getItem("user"); // Verifica si el usuario está en el almacenamiento local
      if (storedUser) {
        setUser(JSON.parse(storedUser)); // Establece el usuario actual
      }
      
    };

    checkUserSession();
    
  }, [navigate]);

  return (
    <div>
      <Header user={user} />

      <main class="mt-0 p-2 fs-6 text-justify text-body-secondary">
        <div class="card">
          <div class="card-body ">
            <h2 class="card-title ">Market Scanner Service</h2>
            <hr />
            <p class="card-text ">
              AZBOT is an advanced market scanner tool designed to analyze, in
              real time, the price history of a currency pair or asset and
              evaluate technical indicators such as: Bollinger bands, RSI, MACD
              and volume patterns.
            </p>

            <a href="#" class="btn btn-primary ">
              More info
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
